import Modal from './Modal';

/* Confirmation in the app's own styling instead of window.confirm — it can show
   what is about to be deleted, and stays put while the request is in flight. */
export default function ConfirmDialog({
  open,
  title,
  confirmLabel = 'Delete',
  busyLabel = 'Deleting…',
  cancelLabel = 'Cancel',
  busy = false,
  tone = 'danger',
  onConfirm,
  onCancel,
  children,
}) {
  return (
    <Modal
      open={open}
      onClose={() => { if (!busy) onCancel(); }}
      title={title}
      maxWidth={420}
      footer={
        <>
          <button className="btn btn-ghost" disabled={busy} onClick={onCancel}>{cancelLabel}</button>
          <button
            className={`btn ${tone === 'danger' ? 'btn-danger' : 'btn-primary'}`}
            disabled={busy}
            onClick={onConfirm}
          >
            {busy ? busyLabel : confirmLabel}
          </button>
        </>
      }
    >
      {children}
    </Modal>
  );
}
